import * as THREE from 'three';
import store from '../../redux/store';

function getAudioElementFromMesh(mesh) {
  if (mesh.audioElement && typeof mesh.audioElement.pause === 'function') {
    return mesh.audioElement;
  }
  let el = null;
  mesh.traverse((o) => {
    if (el) return;
    if (
      (o.type === 'PositionalAudio' || o.type === 'Audio') &&
      o.source &&
      o.source.mediaElement
    ) {
      el = o.source.mediaElement;
    }
  });
  return el;
}

/**
 * Pause all HTML video/audio elements and stop Three.js Audio / PositionalAudio on the scene.
 */
export function stopAllSceneMedia(scene) {
  if (!scene) return;

  const state = store.getState();
  const sceneVideos = state.assets_object?.sceneVideos || [];
  const sceneAudios = state.assets_object?.sceneAudios || [];

  const seenVideos = new Set();
  const pauseVideo = (video) => {
    if (!video || typeof video.pause !== 'function' || seenVideos.has(video)) return;
    seenVideos.add(video);
    video.pause();
  };

  sceneVideos.forEach((mesh) => {
    if (!mesh) return;
    const video =
      mesh.videoElement ||
      (mesh.material?.map &&
      mesh.material.map instanceof THREE.VideoTexture
        ? mesh.material.map.image
        : null);
    pauseVideo(video);
  });

  const seenAudios = new Set();
  const pauseAudioEl = (audio) => {
    if (!audio || typeof audio.pause !== 'function' || seenAudios.has(audio)) return;
    seenAudios.add(audio);
    audio.pause();
  };

  const processAudioMesh = (mesh) => {
    if (!mesh) return;
    pauseAudioEl(getAudioElementFromMesh(mesh));
  };

  sceneAudios.forEach(processAudioMesh);

  scene.traverse((obj) => {
    if (obj.deleteType === 'audio' && obj.audioElement) {
      processAudioMesh(obj);
    }

    if (obj.type === 'Audio' || obj.type === 'PositionalAudio') {
      try {
        if (obj.isPlaying && typeof obj.stop === 'function') {
          obj.stop();
        }
      } catch (_) {}
    }

    const materials = Array.isArray(obj.material)
      ? obj.material
      : obj.material
        ? [obj.material]
        : [];
    materials.forEach((mat) => {
      if (mat?.map instanceof THREE.VideoTexture && mat.map.image) {
        pauseVideo(mat.map.image);
      }
    });

    if (obj.videoElement) {
      pauseVideo(obj.videoElement);
    }

    const dom = obj.userData?.domElement;
    if (dom && typeof dom.pause === 'function') {
      dom.pause();
    }
  });
}
